<div class="add-aegis-modal">
    <div class="modal-header custom-header">
        <div>
            <h5 class="title">Add {{candidates?.length}} candidate{{candidates?.length > 1 ? 's' : ''}} to Aegis</h5>
            <p class="subtitle">Select an existing Job to add this candidate</p>
        </div>
        <span class="pointer f-12" (click)="dismissModel()"><i class="fa-solid fa-xmark"></i></span>

    </div>

    <div class="modal-body custom-body">
        <div class="search-box">
            <span class="search-icon"></span>
            <input data-testid="auto-app-add-candidate-aegis-modal-input-1" type="text" [formControl]="searchMandateFormControll"
                placeholder="Search by Job Name">
        </div>

        <p class="all-jobs-label">All Jobs</p>

        <div class="job-list">
            <div class="job-list__placeholder" *ngIf="paginatedMandateList.length === 0">
                <div *ngIf="isLoadingMandates" class="loading-spinner">
                    <img style="height: 100px; width: 100px;" src="../../../assets/rolling-loader.gif" alt="Loading    ">   
                </div>

                <div *ngIf="!isLoadingMandates" class="no-jobs">
                    <img style="height: 173px; width: 310px;" src="../../../assets/empty_state_aegis_mandate.png" alt="Empty Mandate">
                    <p class="f-12 weight-600 m-0" style="color: #484B59;">No Jobs found</p>
                    <p class="f-10 weight-500 m-0" style="color: #969696;">There are no available Jobs to add this candidate.</p>
                </div>
            </div>

            <ng-container *ngIf="paginatedMandateList.length">
                <div class="job-item" *ngFor="let mandate of paginatedMandateList"
                    [class.selected]="selectedMandateId === mandate?.mandateid" (click)="selectMandate(mandate)">

                    <input data-testid="auto-app-add-candidate-aegis-modal-input-2" type="radio" (click)="$event.stopPropagation(); selectMandate(mandate)" name="mandateSelection"
                        [value]="mandate.mandateid" [checked]="selectedMandateId === mandate?.mandateid">

                <div class="job-content">
                    <p class="job-title">{{ mandate?.mandatename }}</p>
                    <div class="job-meta">
                        <span class="meta-icon briefcase"></span>
                        <span>{{ mandate?.mandatestatus ? mandate?.mandatestatus : 'N/A' }}</span>
                        <span class="meta-dot"></span>
                        <span class="meta-icon location"></span>
                        <span>
                            {{ mandate.mandatelocations.length > 0 && mandate.mandatelocations[0] ? mandate.mandatelocations[0] : 'Mandate Not Available'}}
                            {{ mandate.mandatelocations.length > 1 ? '+' + (mandate.mandatelocations.length - 1) : '' }}
                        </span>
                    </div>
                </div>
            </div>
            </ng-container>
        </div>

        <div class="pagination-row" *ngIf="mandateList.length > mandatesPerPage">
            <ngb-pagination [collectionSize]="mandateList.length" [pageSize]="mandatesPerPage" [maxSize]="5"
                [rotate]="true" [ellipses]="false" [boundaryLinks]="false" (pageChange)="setPage($event)"
                [(page)]="currentPage">
                <ng-template ngbPaginationPrevious>&lt;</ng-template>
                <ng-template ngbPaginationNext>&gt;</ng-template>
            </ngb-pagination>
        </div>
    </div>

    <div class="modal-footer custom-footer">
        <button data-testid="auto-app-add-candidate-aegis-modal-button-1" class="btn-trms-white mr-1" (click)="dismissModel()">Cancel</button>
        <button data-testid="auto-app-add-candidate-aegis-modal-button-2" class="btn-trms-medium"
            [ngClass]="{ 'bg-gray': !selectedMandateId,  'text-center': showAddToAegisSpinner }"
            (click)="tagCandidateToMandate()" [disabled]="!selectedMandateId">
            <span [ngClass]="{ 'spinner-border text-white spinner-size': showAddToAegisSpinner }"
                [ngStyle]="{ 'width: 20px; height: 20px;': showAddToAegisSpinner }">
                {{showAddToAegisSpinner ? '' : 'Add To Aegis'}}
            </span>
        </button>
    </div>
</div>


<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
    <span class="successCheck"><i class="fal fa-check"></i> </span>
    <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert error-message-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
    <span class="errorCheck"><i class="fal fa-times"></i></span>
    <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>